import React from 'react';

const FaqItem = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  
  return (
    <div className="faq-item mb-4 rounded-lg overflow-hidden" style={{ 
      background: 'var(--card-bg)',
      border: '1px solid transparent',
      backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    }}>
      <button 
        className="w-full flex justify-between items-center p-4 text-left focus:outline-none"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <h3 className="font-bold text-lg pr-2" style={{ color: 'var(--text-primary)' }}>
          {question}
        </h3>
        <span className="text-2xl font-bold transition-transform duration-300 flex-shrink-0" style={{ 
          color: 'var(--text-accent)',
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(90deg)'
        }}>
          {isExpanded ? '−' : '+'}
        </span>
      </button>
      
      <div 
        className="px-4 overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isExpanded ? '1000px' : '0',
          opacity: isExpanded ? 1 : 0,
          paddingBottom: isExpanded ? '1rem' : '0'
        }}
      >
        <p className="pb-2 mt-4" style={{ color: 'var(--text-primary)' }}>
          {answer}
        </p>
      </div>
    </div>
  );
};

export default FaqItem;
